import React from "react";
import { useAuth } from "./AuthProvider.tsx";

interface AuthGuardProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, requiredRole }) => {
  const { authenticated, loading } = useAuth();

  if (loading) {
    return <div></div>;
  }

  if (!authenticated) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
